module.exports = __webpack_public_path__ + "img/imagem_login.fbbc83af.jpg";